<template>
    <div class="AddressSpotItem">
        <span class="f2m-localisation" />
        {{ item }}
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: String,
            required: true,
        },
    },
};

</script>

<style lang="scss" scoped>
.AddressSpotItem {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
